var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaelano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 28,
    viewBox: "0 0 183 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26.4299H5.4918V13.7043L11.7563 21.718L14.0552 21.6578L20.3803 14.1321V26.4299H25.8402V0.519234H24.4449L13.8987 14.6169H12.9217L0.683282 0.03125L0 0.703021V26.4299Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0168 0.734375L27.6411 26.4296H33.1297L45.6012 0.734375H40.0168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5293 15.418L48.9534 26.4293H42.5293L39.4609 20.0982L42.5293 15.418Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2559 0.734375V26.4296H70.451V21.5656H55.4667V16.1502H68.7747V11.6538H55.6519V5.96595H70.451V0.734375H50.2559Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1035 0.734375V26.4296H95.2986V21.3818H80.6879V0.734375H75.1035Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4629 26.4296L111.678 0.734375H113.447L126.289 26.4296H120.146L112.378 10.6462L108.048 18.7201L114.75 18.9039L114.657 23.4003L105.35 23.4922L103.862 26.4296H98.4629Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.15 0V26.4304H133.454L133.827 12.2978L150.485 26.4304L150.858 0.735145H145.833L145.925 15.2352L128.15 0Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.822 0.125C161.284 0.125 155.172 6.15192 155.172 13.5858C155.172 17.7019 157.05 21.3903 160.003 23.8588L163.005 18.7318C161.763 17.3661 161.006 15.5599 161.006 13.5858C161.006 9.32699 164.505 5.87624 168.825 5.87624C173.145 5.87624 176.641 9.32699 176.641 13.5858C176.641 17.8445 173.142 21.2953 168.825 21.2953C168.653 21.2953 168.487 21.2921 168.321 21.2763L165.224 26.5712C166.373 26.8817 167.577 27.0465 168.825 27.0465C176.364 27.0465 182.472 21.0196 182.472 13.5858C182.472 6.15192 176.357 0.125 168.822 0.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaelano);
export default __webpack_public_path__ + "static/media/MAELANO.a7dea227e3f13fc082cfcbf47af4aa68.svg";
export { ForwardRef as ReactComponent };